
/**
 * AppPageConfig: 页面数据列表对象
 * Data: 单个页面数据
 */
export { AppPageConfig, Data } from './xmlconfig/app.page.config';
export {AppPageElementType} from './xmlconfig/app.page.element.type';
export {AppElementSelectItem} from './xmlconfig/app.element.selectitem';
export {AppSelectItems} from './xmlconfig/app.select.items';
export {AppPageValidates} from './xmlconfig/app.page.validates';
export {AppPageTemplate} from './xmlconfig/app.page.template';
export {AppPageRelationships} from './xmlconfig/app.page.relationships';
/**
 * BaseModal
 */
export { BaseModal } from './base';